/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderDevicePayResponseSchema = z.object({
	order_number: z.int(),
});
